const PAGE = { x: 0, y: 0, w: 1125, h: 810 };
export const LAYOUTS = {
    "wall-portrait-caption": {
        id: "wall-portrait-caption",
        label: "لوحة عمودية كبيرة مع عنوان",
        reference: "ص 14",
        background: "wall",
        hasCaption: true,
        slots: [{ kind: "frame", stroke: true, rect: { x: 337.1, y: 25.3, w: 459.6, h: 690.5 } }],
    },
    "wall-portrait": {
        id: "wall-portrait",
        label: "لوحة عمودية بإطار",
        reference: "ص 16",
        background: "wall",
        slots: [{ kind: "frame", stroke: true, rect: { x: 368.8, y: 84.2, w: 387.4, h: 641.6 } }],
    },
    "wall-mural": {
        id: "wall-mural",
        label: "جدارية بدون إطار",
        reference: "ص 19 / 21 / 23",
        background: "wall",
        slots: [{ kind: "natural", height: 677, top: 34, centerX: 562.5, maxWidth: 1000, placeholderRatio: 0.6652 }],
    },
    "wall-landscape": {
        id: "wall-landscape",
        label: "لوحة أفقية بإطار",
        reference: "ص 26",
        background: "wall",
        slots: [{ kind: "frame", stroke: true, rect: { x: 235.7, y: 133.7, w: 653.6, h: 542.6 } }],
    },
    "wall-square": {
        id: "wall-square",
        label: "لوحة مربعة بإطار",
        reference: "ص 29 / 32 / 34",
        background: "wall",
        slots: [{ kind: "frame", stroke: true, rect: { x: 286.2, y: 128.7, w: 552.8, h: 552.8 } }],
    },
    "wall-triptych": {
        id: "wall-triptych",
        label: "ثلاث لوحات",
        reference: "ص 17",
        background: "wall",
        slots: [
            { kind: "frame", stroke: true, rect: { x: 718.3, y: 191.6, w: 284.5, h: 504.4 } },
            { kind: "frame", stroke: true, rect: { x: 411.2, y: 191.6, w: 284.5, h: 504.4 } },
            { kind: "frame", stroke: true, rect: { x: 100.5, y: 191.6, w: 288.1, h: 504.4 } },
        ],
    },
    "wall-quad": {
        id: "wall-quad",
        label: "أربع لوحات",
        reference: "ص 36",
        background: "wall",
        slots: [
            { kind: "frame", stroke: true, rect: { x: 777.4, y: 187.8, w: 222, h: 432.9 } },
            { kind: "frame", stroke: true, rect: { x: 540.9, y: 185.2, w: 220.2, h: 437 } },
            { kind: "frame", stroke: true, rect: { x: 283.3, y: 185.2, w: 240, h: 438.1 } },
            { kind: "frame", stroke: true, rect: { x: 32.7, y: 185.2, w: 235.4, h: 438.1 } },
        ],
    },
    "photo-full": {
        id: "photo-full",
        label: "صورة تطبيق بملء الصفحة",
        reference: "ص 15 / 28 / 31 / 37",
        background: "dark",
        slots: [{ kind: "frame", stroke: false, rect: PAGE }],
    },
    "photo-dark": {
        id: "photo-dark",
        label: "صورة تطبيق عمودية على خلفية داكنة",
        reference: "ص 20 / 24 / 25",
        background: "dark",
        slots: [{ kind: "natural", height: 810, top: 0, centerX: 562.5, maxWidth: 1027.5, placeholderRatio: 0.5628 }],
    },
    "photo-dark-wide": {
        id: "photo-dark-wide",
        label: "صورة تطبيق عريضة على خلفية داكنة",
        reference: "ص 18",
        background: "dark",
        slots: [{ kind: "frame", stroke: false, rect: { x: 48.9, y: 0, w: 1027.5, h: 810 } }],
    },
    // «الخيار N» (OptionPage.jsx): الصورة بالنص الأيسر + عنوان ووصف
    option: {
        id: "option",
        label: "خيار (صورة + عنوان ووصف)",
        reference: "العربي ص 19",
        background: "option",
        slots: [{ kind: "frame", stroke: false, rect: { x: 0, y: 0, w: 562.5, h: 810 } }],
    },
};
export const LAYOUT_ORDER = [
    "wall-portrait-caption",
    "wall-portrait",
    "wall-mural",
    "wall-landscape",
    "wall-square",
    "wall-triptych",
    "wall-quad",
    "photo-full",
    "photo-dark",
    "photo-dark-wide",
    "option",
];
